import React from 'react';
import { Icon } from '@mdi/react';
import * as set from '@mdi/js';
import PropTypes from 'prop-types';
import { Tooltip } from '@material-ui/core';

const MDIconButton = ({
  iconPath,
  className,
  color,
  size,
  reverse,
  onClick,
  tooltip,
}) => {
  const iconSet = set;
  const solvedIcon = iconSet[iconPath];
  return solvedIcon ? (
    <Tooltip title={tooltip}>
      <button
        type="button"
        className="mdi-icon-button tooltip-test"
        onClick={onClick}
      >
        <Icon
          className={` ${className} ${reverse ? 'mdi-reverse' : ''}`}
          path={solvedIcon}
          color={color}
          size={size}
          id={iconPath}
        />
      </button>
    </Tooltip>
  ) : null;
};

MDIconButton.propTypes = {
  iconPath: PropTypes.string.isRequired,
  className: PropTypes.string,
  color: PropTypes.string,
  tooltip: PropTypes.string,
  size: PropTypes.number,
  reverse: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

MDIconButton.defaultProps = {
  className: '',
  color: '',
  size: 1,
  reverse: false,
  tooltip: '',
};

export default MDIconButton;
